// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__BEwKl","wrapper_page":"Loader_wrapper_page__jrNiN","loader":"Loader_loader__lqUPL","lds-roller":"Loader_lds-roller__5IWLs"};